"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6399],{

/***/ 6399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_HeroFormCTA; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/utils/dist/index.js
var dist = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/@wds/button/dist/index.es.js + 1 modules
var index_es = __webpack_require__(7837);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var dist_index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var typography_dist_index_es = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@wds/grid/dist/index.es.js
var grid_dist_index_es = __webpack_require__(8597);
// EXTERNAL MODULE: ./node_modules/@wds/input/dist/index.es.js + 1 modules
var input_dist_index_es = __webpack_require__(7634);
// EXTERNAL MODULE: ./node_modules/@wds/checkbox/dist/index.es.js
var checkbox_dist_index_es = __webpack_require__(7277);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/StaticContext/index.js
var StaticContext = __webpack_require__(6787);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Recaptcha/index.js + 1 modules
var Recaptcha = __webpack_require__(6537);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/components/core/Button/index.ts + 1 modules
var Button = __webpack_require__(5709);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./src/static/images/logos/facebook.png
/* harmony default export */ var facebook = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/facebook.a94c5189.png","height":41,"width":42,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9klEQVR42mOwiZx+xTZqxm8g/cUhZsZXWa9JXxkser9IeU36ZR894w4DUPIpEP93jJn5Xztgyv/m/s3/X77++P/gsWv/GWz73jMAdT4C4v9u8bP+MTC0/L//6NX/t+8+/avr2vDfJHTqa5AJj4FG/TcLm/avZ/r2/58+f/9/9cbjfxmVy/+bh017A1YAMl7Ga9K/W3ef/YeCf3sOXfnPYNIDVvAIiP87xc78x+A04f/zlx/+Hzh27R+DXvd/94RZr0FueApVAHLU/xevgAqOXv3PoNcFUvAeZMIlIP4NVPCFwbH/6+Nnb3/vO3z1B4Nx90/3hFm3AeyWneQq7RFtAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/static/images/logos/google.png
/* harmony default export */ var google = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/google.8c73b61c.png","height":42,"width":41,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA8klEQVR42mMAgVuB6qLX1LVWXtfQ/H9NQwuEr1/T0PFhAIFDDKZCVxm0b17XBEqqa+0ASiy6pqH995qmbjkDCLxbzzPtXpby/8sMOvEMUPCfgYGZAQa+HGN49vUww20GIFi0ioExqW73toiG/fdi6/aeBeLjDD8OMzx4e5DzEQMUxDbsWRNXt+9UbP3ebzF1+/4zXN6j0F653ua/wCrXSgYoiGreIhNXc/BHTP3eywwMxXnsOqtcDrqvcfrvstrlmssa+4PuK8L+h/Ut+ptQctqaAQQWbTVmc17t3Oa6xumx62qX985rLbZbb2MwYmBgYAAAA2NkXnQmTs8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/app/helpers/assetLoading.ts
var assetLoading = __webpack_require__(98);
;// CONCATENATED MODULE: ./src/app/components/HeroFormCTA/useStyles.ts






var useStyle = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    return {
        ctaFormField: function(param) {
            var isEnterpriseThankYou = param.isEnterpriseThankYou;
            var inputBase = {
                fontSize: "15px",
                padding: [
                    0,
                    theme.spacing[3]
                ]
            };
            if (isEnterpriseThankYou) {
                return {
                    margin: "0 auto",
                    padding: [
                        theme.spacing[3],
                        0,
                        0,
                        0
                    ],
                    width: "224px",
                    "@media (max-width: 374px)": {
                        height: "62px"
                    },
                    // The wrench input used does not allow addition of a classname
                    "& input": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputBase), {
                        height: "50px",
                        "@media (max-width: 374px)": {
                            height: "48px"
                        }
                    }),
                    "& label > span": {
                        color: theme.palette.text.light
                    }
                };
            }
            return {
                margin: 0,
                padding: [
                    theme.spacing[1],
                    0,
                    theme.spacing[3]
                ],
                "& input": inputBase
            };
        },
        ctaLabel: {
            display: "block",
            boxSizing: "border-box",
            marginBottom: "4px",
            // The wrench button used does not allow addition of a classname
            "& > span": {
                fontSize: "13px",
                lineHeight: "1.5em",
                fontWeight: 500
            }
        },
        visuallyHidden: {
            clip: " rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: "1px",
            width: "1px",
            overflow: "hidden",
            position: "absolute",
            whiteSpace: "nowrap"
        },
        hardRule: function(param) {
            var isEnterpriseThankYou = param.isEnterpriseThankYou;
            return {
                borderTop: isEnterpriseThankYou ? "none" : [
                    2,
                    "solid",
                    theme.palette.border.main
                ],
                width: isEnterpriseThankYou ? 0 : "100%"
            };
        },
        /** Only applies to `enterpriseThankYou` */ enterpriseThankYouForm: {
            // The wrench button used does not allow addition of a classname
            "& button": {
                backgroundColor: theme.palette.background.light,
                height: "50px",
                width: "140px",
                margin: [
                    20,
                    "auto",
                    0
                ],
                padding: 0,
                color: theme.palette.text.dark,
                border: [
                    1,
                    "solid",
                    theme.palette.text.dark
                ],
                "&:hover, &:focus": {
                    borderColor: theme.palette.border.main,
                    backgroundColor: theme.palette.background.light
                },
                "&:active": {
                    borderColor: theme.palette.border.active,
                    backgroundColor: theme.palette.background.light
                }
            }
        },
        facebookButton: {
            // The wrench button used does not allow addition of a classname
            "& > a": {
                boxSizing: "border-box",
                fontSize: "15px",
                border: "none",
                backgroundRepeat: "no-repeat",
                backgroundSize: theme.spacing[5],
                backgroundColor: "#3d5a98",
                color: theme.palette.text.light,
                backgroundPosition: "10% 41%",
                backgroundImage: "url(".concat((0,assetLoading/* getSrc */.d)(facebook), ")"),
                "&:focus, &:hover": {
                    backgroundColor: "#4a71c3",
                    textDecoration: "none"
                },
                "& > span": {
                    marginLeft: theme.spacing[4]
                }
            }
        },
        googleButton: {
            // The wrench button used does not allow addition of a classname
            "& > a": {
                boxShadow: "0 0 1px 0 rgba(0, 0, 0, 0.12), 0 0 8px 0 rgba(0, 0, 0, 0.12)",
                boxSizing: "border-box",
                fontSize: "15px",
                border: "none",
                backgroundRepeat: "no-repeat",
                backgroundSize: theme.spacing[5],
                backgroundColor: theme.palette.background.light,
                color: theme.palette.text.darkMuted,
                backgroundPosition: "13% 50%",
                backgroundImage: "url(".concat((0,assetLoading/* getSrc */.d)(google), ")"),
                "&:focus, &:hover": {
                    backgroundColor: theme.palette.background.main,
                    textDecoration: "none"
                },
                "& > span": {
                    marginLeft: theme.spacing[4]
                }
            }
        },
        disclaimerContainer: {
            "& a": {
                color: theme.palette.link.main
            }
        }
    };
});
/* harmony default export */ var useStyles = (useStyle);

;// CONCATENATED MODULE: ./src/app/components/HeroFormCTA/index.tsx














/** Type-wrapper for `Typography` to allow use of `dangerouslySetInnerHTML`  */ var TypographyWithInnerHTML = typography_dist_index_es/* Typography */.ZT;
var HeroFormCTA = function(param) {
    var className = param.className, ctaFormEmail = param.ctaFormEmail, ctaFormEmailPlaceholder = param.ctaFormEmailPlaceholder, ctaFormNewsletterOptOut = param.ctaFormNewsletterOptOut, ctaFormPassword = param.ctaFormPassword, ctaFormPasswordPlaceholder = param.ctaFormPasswordPlaceholder, ctaFormPrivacyConsent = param.ctaFormPrivacyConsent, ctaFormSubmit = param.ctaFormSubmit, _ctaFacebook = param.ctaFacebook, ctaFacebook = _ctaFacebook === void 0 ? "FACEBOOK" : _ctaFacebook, _ctaGoogle = param.ctaGoogle, ctaGoogle = _ctaGoogle === void 0 ? "GOOGLE" : _ctaGoogle, disclaimer = param.disclaimer, _utSource = param.utSource, utSource = _utSource === void 0 ? "" : _utSource, _utSource2 = param.utSource2, utSource2 = _utSource2 === void 0 ? "" : _utSource2, _showThirdPartySignUpActions = param.showThirdPartySignUpActions, showThirdPartySignUpActions = _showThirdPartySignUpActions === void 0 ? true : _showThirdPartySignUpActions, _showDisclaimer = param.showDisclaimer, showDisclaimer = _showDisclaimer === void 0 ? true : _showDisclaimer, isEnterpriseThankYou = param.isEnterpriseThankYou;
    var utSource3 = "HeroFormCTA";
    var ref = (0,react.useContext)(StaticContext/* StaticContext */.vN), countryCode = ref.environment.countryCode;
    var ref1 = useStyles({
        isEnterpriseThankYou: isEnterpriseThankYou
    }), hardRule = ref1.hardRule, enterpriseThankYouForm = ref1.enterpriseThankYouForm, ctaFormField = ref1.ctaFormField, ctaLabel = ref1.ctaLabel, visuallyHidden = ref1.visuallyHidden, facebookButton = ref1.facebookButton, googleButton = ref1.googleButton, disclaimerContainer = ref1.disclaimerContainer;
    var containerClasses = classnames_default()("sm-hero-form-cta", className);
    var ref2 = (0,react.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(""), password = ref3[0], setPassword = ref3[1];
    var handleEmailChange = function(e) {
        setEmail(e.target.value);
    };
    var handlePasswordChange = function(e) {
        setPassword(e.target.value);
    };
    var recaptchaContext = (0,Recaptcha/* useRecaptcha */.Z)({
        actionName: "user_signup",
        successCallback: undefined,
        siteKey: undefined,
        useEnterprise: undefined,
        errorCallback: undefined
    });
    // submits the form action when reCAPTCHA sets the token properly
    (0,react.useEffect)(function() {
        if (recaptchaContext.greToken.length) {
            document.getElementById("signup_form").submit();
        }
    }, [
        recaptchaContext.greToken
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Box */.x, {
        className: containerClasses,
        pt: 7,
        "data-testid": "HeroFormCTA",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                id: "signup_form",
                method: "post",
                action: (0,dist.createURL)("/user/sign-up/", {
                    ut_source: utSource,
                    ut_source2: utSource2,
                    ut_source3: utSource3,
                    ut_ctatext: ctaFormSubmit
                }),
                className: isEnterpriseThankYou ? enterpriseThankYouForm : undefined,
                "data-testid": "HeroFormCTA__Form",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Recaptcha/* Recaptcha */.e, {
                        greToken: recaptchaContext.greToken,
                        showError: recaptchaContext.showError,
                        setShowError: recaptchaContext.setShowError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "username",
                        className: "input-username",
                        value: email
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "password_confirm",
                        className: "input-password_confirm",
                        value: password
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Box */.x, {
                        element: "div",
                        className: ctaFormField,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: isEnterpriseThankYou ? visuallyHidden : ctaLabel,
                                htmlFor: "email-input",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_dist_index_es/* Typography */.ZT, {
                                    component: "span",
                                    variant: "bodySm",
                                    children: ctaFormEmail
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_es/* Input */.I, {
                                id: "email-input",
                                type: "email",
                                name: "email",
                                placeholder: ctaFormEmailPlaceholder,
                                required: true,
                                stretched: true,
                                onChange: handleEmailChange,
                                value: email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Box */.x, {
                        element: "div",
                        className: ctaFormField,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: isEnterpriseThankYou ? visuallyHidden : ctaLabel,
                                htmlFor: "password-input",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_dist_index_es/* Typography */.ZT, {
                                    component: "span",
                                    variant: "bodySm",
                                    children: ctaFormPassword
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_es/* Input */.I, {
                                id: "password-input",
                                type: "password",
                                name: "password",
                                placeholder: ctaFormPasswordPlaceholder,
                                required: true,
                                stretched: true,
                                onChange: handlePasswordChange,
                                value: password
                            })
                        ]
                    }),
                    countryCode.toLowerCase() === "de" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Box */.x, {
                                element: "div",
                                className: ctaFormField,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_es/* Checkbox */.X, {
                                    // weird required type from Wrench due to merge of HTMLAttribute and custom type
                                    // ((boolean | ReactChild | ReactFragment | ReactPortal | null) & string) | undefined
                                    label: ctaFormPrivacyConsent,
                                    id: "privacy-consents",
                                    name: "privacy-consents",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Box */.x, {
                                element: "div",
                                className: ctaFormField,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_es/* Checkbox */.X, {
                                    label: ctaFormNewsletterOptOut,
                                    id: "subscribe-to-newsletter",
                                    name: "subscribe-to-newsletter"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        size: "lg",
                        stretched: true,
                        onClick: recaptchaContext.fireGRE,
                        children: ctaFormSubmit
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Box */.x, {
                mb: 4,
                mt: 4,
                className: hardRule,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            }),
            showThirdPartySignUpActions && /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_dist_index_es/* Grid */.r, {
                noBleeds: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_dist_index_es/* Grid.Item */.r.Item, {
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: facebookButton,
                            stretched: true,
                            href: (0,dist.createURL)("/user/third-party/", {
                                third_party: "facebook",
                                action: "sign_up"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: ctaFacebook
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_dist_index_es/* Grid.Item */.r.Item, {
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: googleButton,
                            stretched: true,
                            href: (0,dist.createURL)("/user/third-party/", {
                                third_party: "google",
                                action: "sign_up"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: ctaGoogle
                            })
                        })
                    })
                ]
            }),
            showDisclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Box */.x, {
                mt: 3,
                className: disclaimerContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyWithInnerHTML, {
                    align: "center",
                    component: "div",
                    variant: "bodySm",
                    color: "darkMuted",
                    dangerouslySetInnerHTML: {
                        __html: "".concat(disclaimer)
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var components_HeroFormCTA = (HeroFormCTA);


/***/ }),

/***/ 5709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/button/dist/index.es.js + 1 modules
var index_es = __webpack_require__(7837);
;// CONCATENATED MODULE: ./src/app/components/core/Button/Button.tsx






/**
 * @description Generic Stylable Button.
 * This component can be used in place of the `@wds/button` component to
 * modify the styles, until the `@wds/button` version supports className prop
 * passthrough.
 */ function Button(_param) {
    var tmp = _param.element, Element = tmp === void 0 ? "div" : tmp, className = _param.className, componentProps = _param.componentProps, buttonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "element",
        "className",
        "componentProps"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, componentProps), {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, (0,_object_spread/* default */.Z)({}, buttonProps))
    }));
};

;// CONCATENATED MODULE: ./src/app/components/core/Button/index.ts




/***/ }),

/***/ 98:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getSrc; }
/* harmony export */ });
/** Shape of assets loaded with the next.js loader */ /**
 * Helper to get the url of an asset
 *
 * Workaround to get an assets `src` URL that works with both the next.js and
 * Storybook/Jest asset loader return format.
 *
 * This is just a temporary workaround till Storybook has better support for Next.js
 * See: https://storybook.js.org/blog/integrate-nextjs-and-storybook-automatically/
 *
 * @returns the normalized url of `asset`
 */ var getSrc = function(asset) {
    return typeof asset === "string" ? asset : asset.src;
};


/***/ })

}]);